import type { LookoRouteObject } from '../LookoRouteObject';

export const 매니저_라우터 = {
  ['shop-list']: {
    path: '/manager/shop-list',
    async lazy() {
      const { default: Page } = await import('@/router/manager/shop-list/ShopListPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '샵 목록',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  ['create-coupon']: {
    path: '/manager/create-coupon',
    async lazy() {
      const { default: Page } = await import('@/router/manager/create-coupon/CreateCouponPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '쿠폰 발급',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  ['credit']: {
    path: '/manager/credit',
    async lazy() {
      const { default: Page } = await import('@/router/manager/credit/CreditPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '크레딧',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  ['credit-issued']: {
    path: '/manager/credit/issued',
    async lazy() {
      const { default: Page } = await import('@/router/manager/credit/크레딧지급/CreditIssuedPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '크레딧 지급',
    },
  } satisfies LookoRouteObject,

  ['credit-deducted']: {
    path: '/manager/credit/deducted',
    async lazy() {
      const { default: Page } = await import('@/router/manager/credit/크레딧차감/CreditDeductedPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '크레딧 차감',
    },
  } satisfies LookoRouteObject,

  ['maintenance-setting']: {
    path: '/manager/maintenance-setting',
    async lazy() {
      const { default: Page } = await import('@/router/manager/maintenance-setting/MaintenanceSettingPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '배포 알림 페이지 게시',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  ['market-items-management']: {
    path: '/manager/market-items-management',
    async lazy() {
      const { default: Page } = await import('@/router/manager/market-item-management/MarketItemManagementPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품글 관리',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  ['consistency-report']: {
    path: '/manager/consistency-report',
    async lazy() {
      const { default: Page } = await import('@/router/manager/consistency-report/ConsistencyReportPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '오류 모니터링',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  ['item-force-update']: {
    path: '/manager/item-force-update',
    async lazy() {
      const { default: Page } = await import('@/router/manager/상품상태_강제_업데이트/상품상태_강제_업데이트_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품상태 강제 업데이트',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};
